export function livestream(livestream) {
    return {
        type: "@livestream/livestream",
        payload: {
            livestream,
        },
    };
}
